import { FC, ReactNode } from 'react';
import { EntityChip, EntityChipProps, Icons } from '@silverfort/sf-components';

export interface ListCellProps {
    children: ReactNode[];
    maxChildrenToDisplay: number;
    onMoreClick?: (element: HTMLElement) => void;
}

const ListCell: FC<ListCellProps> = ({ children, maxChildrenToDisplay, onMoreClick }) => {
    const shouldTruncate = children.length > maxChildrenToDisplay;

    const handleMoreClick: EntityChipProps['onClick'] = (event) => {
        onMoreClick?.(event.currentTarget);
    };

    if (shouldTruncate) {
        const numberOfRemainingChildren = Math.max(children.length - 1, 0);

        return (
            <div className="flex gap-2 items-center">
                {children[0]}
                {!!numberOfRemainingChildren && (
                    <EntityChip
                        className="flex items-center leading-4"
                        icon={Icons.Add}
                        text={numberOfRemainingChildren.toString()}
                        onClick={handleMoreClick}
                    />
                )}
            </div>
        );
    }

    return <div className="flex gap-2 items-center">{children}</div>;
};

export default ListCell;
